module.exports = __webpack_public_path__ + "img/success.ad53a3e3.svg";